import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ExcSelectComponent} from 'exc-controls';

@Component({
  selector: 'app-defaultable-input',
  templateUrl: './defaultable-input.component.html',
  styles: []
})
export class DefaultableInputComponent implements OnInit {

  @Input('fieldName') fieldName: string;
  @Input('label') label: string;
  @Input('isRequired') isRequired = false;
  @Input() nullOptionText: string = '';
  _value: string = null;
  get value(): any {
    return this._value;
  }
  // @Input('value') set value(value: any) {
  //   if (value && value !== null) {
  //     this._value = value.toString();
  //   } else {
  //     this._value = null;
  //   }
  // }
  @Input('value') set value(value: any) {
    if (value && value !== null) {
      this._value = value.toString();
    } else {
      this._value = '';
    }
  }
  @Output() changedValue: EventEmitter<any> = new EventEmitter<any>(false);
  @ViewChild('selectControl') selectControl: ExcSelectComponent;
  isDefault = true;
  options: any[] = [];
  constructor(private excDss: DefaultSettingsService) { }

  ngOnInit() {
    if (this.excDss.Defaults[this.fieldName] !== undefined && this.excDss.Defaults[this.fieldName].length > 0) {
      if (this.isRequired === false) {
        this.options.push({
          text: this.nullOptionText || '',
          value: '',
          selected: this._value === null || this._value === undefined || this._value === ''
        });
      }

      for (const x of this.excDss.Defaults[this.fieldName]) {
        this.options.push({
          text: x.toString(),
          value: x.toString(),
          selected: (this._value !== undefined && this._value !== null && x.toString() === this._value.toString())
        });
      }
    }

    this.isDefault = this.options.length > 0;
  }

  setValue(e) {
    this._value = e;
    if (this.options.length > 0) {
      for (const x of this.options) {
        x.selected = x.value.toString() === e.toString();
      }
      this.changedValue.emit({field: this.fieldName, value: e.toString()});
    } else {
      if (this._value === '') {
        this._value = null;
      }
      this.changedValue.emit({field: this.fieldName, value: e});

    }
  }
}
